import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'model-property-view',
  templateUrl: './model-property-view.component.html',
  styleUrls: ['./model-property-view.component.sass']
})
export class ModelPropertyViewComponent implements OnInit {

  @Input() propertyName: string;
  @Input() propertyValue: string;
  @Output() propertyValueChange: EventEmitter<string> = new EventEmitter();
  @Input() editable: boolean = false;
  @Input() linked: boolean = false;
  
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  @Output() linkClicked: EventEmitter<any> = new EventEmitter();

  @ViewChild('input') inputElement: ElementRef;

  public editMode: boolean = false;

  private origValue: string;

  constructor() { }

  ngOnInit(): void {
  }

  onEditClick() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      }, 0);
      this.origValue = this.propertyValue;
    } else {
      this.emitEvent();
    }
  }

  onKeydown(event) {
    switch (event.key) {
      case "Escape":
        this.cancelEdit();
        break;
      case "Enter":
        if (this.editMode) {
          this.emitEvent();
          this.editMode = false;
        }
        break;
    }
  }

  emitEvent = () => {
    if (this.origValue != this.propertyValue) {
      this.propertyValueChange.emit(this.propertyValue);
      this.valueChange.emit(
        {
          propertyValue: this.propertyValue,
          propertyName: this.propertyName
        }
      );
    }
  }

  cancelEdit = () => {
    if (this.editMode) {
      this.propertyValue = this.origValue;
      this.editMode = false;
    }
  }

  onFocusOut = (event) => {   
    this.cancelEdit();
  }

  onClickLink = (event) => {   
    this.linkClicked.emit(
      {
        propertyValue: this.propertyValue,
        propertyName: this.propertyName
      }
    );
  }
}
